import React from 'react';
import { Link } from 'react-router-dom';
import { Diamond, Clock } from 'lucide-react';

const EventTransport = () => {
  return (
    <section className="bg-[#0f0f10] py-16 sm:py-24">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-16">
          <h2
            className="text-2xl sm:text-3xl md:text-4xl text-white mb-4 sm:mb-6"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Transport événementiel privé
          </h2>
          <p className="text-gray-400 leading-relaxed mb-6 sm:mb-8 text-sm sm:text-base">
            Nous organisons et coordonnons vos multiples trajets avec précision, assurant un 
            transport fluide et confortable pour vos invités. Notre expertise logistique garantit 
            une expérience sans faille, du départ à l'arrivée, pour que chaque participant profite 
            pleinement de l'événement.
          </p>
          <Link
            to="/contact"
            className="inline-block px-8 py-3 border border-white text-white text-sm hover:bg-white hover:text-gray-900 transition-all duration-300 rounded-sm"
          >
            Demander un devis
          </Link>
        </div>

        {/* Features */}
        <div className="grid sm:grid-cols-2 gap-8 sm:gap-12 max-w-2xl mx-auto">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <Diamond className="text-amber-500" size={40} />
            </div>
            <h3 className="text-white text-lg font-medium mb-2">L'expérience de l'exceptionnel</h3>
            <p className="text-gray-400 text-sm">
              Notre expertise en transport multiple garantit une exécution sans faille de vos événements prestigieux.
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <Clock className="text-amber-500" size={40} />
            </div>
            <h3 className="text-white text-lg font-medium mb-2">Le sens du timing</h3>
            <p className="text-gray-400 text-sm">
              Barham Driver vous permet de piloter votre événement en amont et en temps réel.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventTransport;
